import { render, staticRenderFns } from "./UrlsDropdown.vue?vue&type=template&id=ff12d24a&scoped=true&"
import script from "./UrlsDropdown.vue?vue&type=script&lang=js&"
export * from "./UrlsDropdown.vue?vue&type=script&lang=js&"
import style0 from "./UrlsDropdown.vue?vue&type=style&index=0&id=ff12d24a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff12d24a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
